import React, { useEffect, useState } from 'react';
import ReactDOM from 'react-dom/client';
import App from './App';
import { AuthProvider } from './AuthContext';
import { PublicClientApplication, EventType } from '@azure/msal-browser';
import { createMsalConfig } from './authConfig';
import { MsalProvider } from '@azure/msal-react';

const RootComponent = () => {
  const [msalInstance, setMsalInstance] = useState(null);

  useEffect(() => {
    fetch('/api/config')
      .then(response => response.json())
      .then(data => {
        const config = createMsalConfig(data);
        // MSAL should be instantiated outside of the component tree to prevent it from being re-instantiated on re-renders.
        const instance = new PublicClientApplication(config);

        // Default to using the first account if no account is active on page load
        if (!instance.getActiveAccount() && instance.getAllAccounts().length > 0) {
          instance.setActiveAccount(instance.getAllAccounts()[0]);
        }

        // Listen for sign-in event and set active account
        instance.addEventCallback((event) => {
          if (event.eventType === EventType.LOGIN_SUCCESS && event.payload.account) {
            instance.setActiveAccount(event.payload.account);
          }
        });

        setMsalInstance(instance);
      })
      .catch(error => console.error("Error fetching app config:", error));
  }, []);

  if (!msalInstance) {
    return <div>Chargement de l'authentification...</div>;
  }

  return (
    <React.StrictMode>
      <MsalProvider instance={msalInstance}>
        <AuthProvider>
          <App />
        </AuthProvider>
      </MsalProvider>
    </React.StrictMode>
  );
};

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(<RootComponent />);

